export default "__VITE_ASSET__21d3ac01__"